import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	technicalSupport: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	purchasingLicensing: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	atlassianCommunity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	knowledgeBase: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	marketplace: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myAccount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createSupportTicket: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'twg-microsite.footer.resources.heading',
		defaultMessage: 'Resources',
		description: 'Heading for the Resources column in the footer',
	},
	technicalSupport: {
		id: 'twg-microsite.footer.resources.technicalSupport',
		defaultMessage: 'Technical support',
		description: 'Footer link in the Resources column',
	},
	purchasingLicensing: {
		id: 'twg-microsite.footer.resources.purchasingLicensing',
		defaultMessage: 'Purchasing & licensing',
		description: 'Footer link in the Resources column',
	},
	atlassianCommunity: {
		id: 'twg-microsite.footer.resources.atlassianCommunity',
		defaultMessage: 'Atlassian Community',
		description: 'Footer link in the Resources column',
	},
	knowledgeBase: {
		id: 'twg-microsite.footer.resources.knowledgeBase',
		defaultMessage: 'Knowledge base',
		description: 'Footer link in the Resources column',
	},
	marketplace: {
		id: 'twg-microsite.footer.resources.marketplace',
		defaultMessage: 'Marketplace',
		description: 'Footer link in the Resources column',
	},
	myAccount: {
		id: 'twg-microsite.footer.resources.myAccount',
		defaultMessage: 'My account',
		description: 'Footer link in the Resources column',
	},
	createSupportTicket: {
		id: 'twg-microsite.footer.resources.createSupportTicket',
		defaultMessage: 'Create support ticket →',
		description:
			'Call-to-action link at the bottom of the Resources column for creating a support ticket',
	},
});
